import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "plan-section" }
const _hoisted_2 = {
  key: 0,
  class: "plan-section__content plan-section__content--trial"
}
const _hoisted_3 = { class: "plan-section__row" }
const _hoisted_4 = { class: "plan-section__badge plan-section__badge--trial" }
const _hoisted_5 = { class: "plan-section__days" }
const _hoisted_6 = { class: "plan-section__progress" }
const _hoisted_7 = {
  key: 1,
  class: "plan-section__content plan-section__content--expired"
}
const _hoisted_8 = { class: "plan-section__badge plan-section__badge--expired" }
const _hoisted_9 = {
  key: 2,
  class: "plan-section__content plan-section__content--pro"
}
const _hoisted_10 = {
  key: 3,
  class: "plan-section__content"
}

import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Icon } from "@/components/ui";
import { SETTINGS_BILLING_ROUTE } from "@/router/routes";

const TRIAL_DURATION_DAYS = 14;

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileDropdownTrialSection',
  emits: ["navigate"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const router = useRouter();

const trialStatus = computed(() => store.getters.trialStatus?.data);
const subscriptionStatus = computed(() => store.getters.subscriptionStatus?.data);
const isFreeTrialActive = computed(() => store.getters.isFreeTrialActive);
const isViewOnlyMode = computed(() => store.getters.isViewOnlyMode);

const isPaidSubscriber = computed(() => {
  const subStatus = subscriptionStatus.value?.status;
  if (subStatus === "active" || subStatus === "trialing") {
    return true;
  }
  const trial = trialStatus.value;
  return trial?.type === "stripe_subscription" && ["active", "trialing"].includes(trial?.status);
});

const daysRemaining = computed(() => trialStatus.value?.daysRemaining ?? 0);

const progressPercent = computed(() => {
  const daysUsed = TRIAL_DURATION_DAYS - daysRemaining.value;
  return Math.min(100, Math.max(0, (daysUsed / TRIAL_DURATION_DAYS) * 100));
});

const handleUpgrade = () => {
  emit("navigate");
  router.push({ name: SETTINGS_BILLING_ROUTE });
};
const handleManageBilling = () => {
  emit("navigate");
  router.push({ name: SETTINGS_BILLING_ROUTE });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isFreeTrialActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_unref(Icon), {
                icon: "mdi:gift-outline",
                width: "12",
                height: "12"
              }),
              _cache[0] || (_cache[0] = _createTextVNode(" Free Trial ", -1))
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(daysRemaining.value) + "d left", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["plan-section__progress-fill", { 'plan-section__progress-fill--warning': daysRemaining.value <= 3 }]),
              style: _normalizeStyle({ width: progressPercent.value + '%' })
            }, null, 6)
          ]),
          _createElementVNode("button", {
            class: "plan-section__btn plan-section__btn--primary",
            onClick: handleUpgrade
          }, [
            _createVNode(_unref(Icon), {
              icon: "mdi:arrow-up-circle-outline",
              width: "14",
              height: "14"
            }),
            _cache[1] || (_cache[1] = _createTextVNode(" Upgrade to paid plan ", -1))
          ])
        ]))
      : (isViewOnlyMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_unref(Icon), {
                icon: "mdi:alert",
                width: "12",
                height: "12"
              }),
              _cache[2] || (_cache[2] = _createTextVNode(" Trial Expired ", -1))
            ]),
            _createElementVNode("button", {
              class: "plan-section__btn plan-section__btn--primary",
              onClick: handleUpgrade
            }, [
              _createVNode(_unref(Icon), {
                icon: "mdi:rocket-launch",
                width: "14",
                height: "14"
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" Upgrade Now ", -1))
            ])
          ]))
        : (isPaidSubscriber.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "plan-section__btn plan-section__btn--manage",
                onClick: handleManageBilling
              }, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:credit-card-outline",
                  width: "14",
                  height: "14"
                }),
                _cache[4] || (_cache[4] = _createTextVNode(" Manage billing ", -1))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "plan-section__btn plan-section__btn--primary plan-section__btn--full plan-section__btn--normal",
                onClick: handleUpgrade
              }, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:arrow-up-circle-outline",
                  width: "14",
                  height: "14"
                }),
                _cache[5] || (_cache[5] = _createTextVNode(" Upgrade to paid plan ", -1))
              ])
            ]))
  ]))
}
}

})